﻿'use strict'
import { App, View } from '../../config/app.js'
import { Modal } from '../../modal.js'

export default function ()
{
	App.Modal.SavedCartShare = new Modal('SavedCartShare', {
		viewMailTo: new View('mailto/shareCart'),
		actionOpenName: 'savedcart share',
		onInit: modal => $(modal.element).on('click', '.btn-default', modal.close),
		onOpen: async (modal, data) =>
		{
			modal.view.model.clear()
			modal.options.viewMailTo.model.clear()
			// id == 'SHARE' will create and share from current cart
			return await App.Store
				.fetch('savedcart', data.id, { 'include': 'item,product', 'nocache': (new Date()).toISOString() })
				.then(model =>
				{
					modal.options.viewMailTo.model.sync(model)
					modal.options.viewMailTo.render().then(() =>
					{
						let subject = 'Shared Shopping Cart' // TODO: Localize

						modal.view.model.sync({
							href: 'mailto:?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(modal.options.viewMailTo.html)
						})
					})
				})
				.catch(function(e)
				{
					document.querySelectorAll('[ui-view="grid/savedcart"]').forEach(el => el.classList.remove('fail'))
					App.Component.HandleErrors(e)
					return false
				})
		}
	})
}
